<div class="view-component"  > 
    <!--div class="view-component-title">
      <span class="mat-headline-6" class="title">Cadastro de Anúncios</span>
    </div-->
    <div class="content">
      <div class="tabcontent">
        <iframe src="assets/docs/privacy.htm" style="width:100%; height:100vh;" frameborder="0"></iframe>
      </div>
    </div>
</div>